import { stripHtmlTags } from "../common/commonFunction";

// function to generate event schema
export const generateCityHomeSchema = (eventSchema = []) => {
    // Generate schema for offers, location, images, and performers
    let itemListElement = generateListForSchema(eventSchema?.events);
    // Construct
    let schema = {
        "@context": "https://schema.org",
        "@graph": itemListElement,
    };

    return schema;
};

const generateListForSchema = (eventList) => {
    let itemListElement = [];
    eventList.forEach((event, index) => {
        const dates = Array.isArray(event.dates) ? event.dates : []; // Ensure dates is an array
        itemListElement.push({
            "@type": "Event",
            "name": event.name || "",
            "startDate": dates[0]?.date || "",
            "endDate": dates[dates.length - 1]?.date || "",
            "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
            "eventStatus": "https://schema.org/EventScheduled",
            "location": {
                "@type": "Place",
                "name": event?.address || "",
                "address": {
                    "@type": "PostalAddress",
                    "addressCountry": event?.country || "",
                    "addressLocality": event?.city || "",
                    "streetAddress": event?.address || "",
                    "postalCode": event?.pin_code || ""
                }
            },
            "image": [generateImageSchema(event) || "https://www.mepass.in/apple-touch-icon-192x192.png"],
            "description": stripHtmlTags(event.description) || stripHtmlTags(event.short_description) || "",
            "offers": generateOfferSchema(event)
        });
    });
    return itemListElement;
}

export const generateImageSchema = (event) => {
    // If banner_image is not available, return default image
    if (!event.banner_image) {
        return ["https://www.mepass.in/apple-touch-icon-192x192.png"];
    }
    return [event.banner_image];
};


// function to generate offer schema
export const generateOfferSchema = (event) => {
    const dates = Array.isArray(event.dates) ? event.dates : [];
    let url = window.location.href;
    //remove // from url 
    url = url.replace(/([^:]\/)\/+/g, "$1");

    return {
        "@type": "Offer",
        "URL": url,
        "availability": "http://schema.org/InStock",
        "name": event?.pass_name || "",
        "price": event?.price_without_tax || "",
        "priceCurrency": "INR",
        "validFrom": dates[0]?.date || "",
    };
};